import { USD } from 'self-service-api/constants/CurrencyCodes';
import { ACTIVE_CURRENCY_CODE_UPDATED } from '../actions/constants/ActionTypes';
const initialState = USD;

const ActiveCurrencyCode = (state = initialState, {
  type,
  payload
}) => {
  switch (type) {
    case ACTIVE_CURRENCY_CODE_UPDATED:
      return payload;

    default:
      return state;
  }
};

export default ActiveCurrencyCode;